export const openRegrasMundoBModal = history => () => history.replace('#modal-regras-mundo-b');
